import { router, gotoGetPermissionsError } from '@/router'
import { getUserPermission } from '@/services'
import { CacheType, getCache, removeCache, setCache } from '../common/cache'
import { getUserLoginSessionKey } from './user'

/**
 * tokenId前缀
 */
function getTokenPreKey() {
  const sisscloudtokenid = getUserLoginSessionKey()
  const apptoken = router.currentRoute.value.params.token

  const key = sisscloudtokenid ? sisscloudtokenid + '|' + apptoken : apptoken

  return key
}

/** 获取token缓存id */
function getTokenId() {
  /**增加tokenId前缀
   * 修复bug：https://cd.sixun.com.cn:8200/zentao/task-view-4857.html
   * 没有sisscloudid的情况时，userLoginSessionKey是undefined，运营平台后台会有问题，getTokenId总是获取到‘undefinedtoken’，TokenId重复了，现象见任务备注
   */
  const key = getTokenPreKey()
  return key + 'token'

  //  return userLoginSessionKey + 'token'
}

/** 接口凭证（路由获取） */
export let token

/**
 * 获取接口凭证
 * @param {*} value
 */
export async function getToken() {
  if (!token) {
    token = await getCache(getTokenId(), CacheType.system)
  }
  // console.log('获取接口凭证----', token)
  return token
}

/**
 * 设置接口凭证
 * @param {*} value
 */
export function setToken(value) {
  token = value
  if (!value) {
    removeCache(getTokenId(), CacheType.system)
  } else {
    setCache({
      id: getTokenId(),
      type: CacheType.system,
      value: token
    })
  }
}

//#region  authToken
/** 获取authToken缓存id */
function getAuthTokenId() {
  const key = getTokenPreKey()
  return key + 'authToken'
}

/** 接口凭证（用于鉴权） */
export let authToken

/**
 * 获取鉴权接口凭证
 * @param {*} value
 */
export async function getAuthToken() {
  if (!authToken) {
    authToken = await getCache(getAuthTokenId(), CacheType.system)
  }
  return authToken
}

/**
 * 设置鉴权接口凭证
 * @param {*} value
 */
export function setAuthToken(value) {
  authToken = value
  if (!value) {
    removeCache(getAuthTokenId(), CacheType.system)
  } else {
    setCache({
      id: getAuthTokenId(),
      type: CacheType.system,
      value: authToken
    })
  }
}
//#endregion

/**
 * 用户权限列表(页面功能权限)
 */
export let userPermissions

export function clearContextUserPermissions() {
  userPermissions = undefined
}

/**
 * 获取用户权限
 * @param {*} value
 */
export async function getContextUserPermissions(isCache = false) {
  if (isCache && userPermissions) {
    return userPermissions
  } else {
    const res = await getUserPermission('Subsite')
    if (res.Code !== 0) return gotoGetPermissionsError(res.Message)
    return (userPermissions = res.Data)
  }
}
